import {
  Dialog,
  DialogActions,
  DialogContent,
  makeStyles,
} from '@material-ui/core';
import { PropsWithChildren } from 'react';
import { Button } from '../common';
import { DialogTitle } from '../common/dialog';

const useStyles = makeStyles({
  paper: {
    width: 480,
  },
  content: {
    padding: '15px 32px 0',
    overflow: 'visible',
  },
});

export interface WarningModalProps extends PropsWithChildren<{}> {
  title: string;
  isOpen: boolean;
  onClose: () => void;
}

export function WarningModal({
  children,
  title,
  isOpen,
  onClose,
}: WarningModalProps) {
  const classes = useStyles();

  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      PaperProps={{
        className: classes.paper,
        elevation: 3,
      }}>
      <DialogTitle onClose={onClose}>{title}</DialogTitle>
      <DialogContent
        data-testid='warning-modal-content'
        className={classes.content}>
        {children}
      </DialogContent>
      <DialogActions>
        <Button variant='outlined' onClick={onClose} data-testid='button-ok'>
          Ok
        </Button>
      </DialogActions>
    </Dialog>
  );
}
